export default __webpack_public_path__ + "static/media/cost-recruit-management.51b4273d.svg";